import { render, staticRenderFns } from "./christmas-loader.vue?vue&type=template&id=64b6b8d6&scoped=true"
import script from "./christmas-loader.vue?vue&type=script&lang=js"
export * from "./christmas-loader.vue?vue&type=script&lang=js"
import style0 from "./christmas-loader.vue?vue&type=style&index=0&id=64b6b8d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b6b8d6",
  null
  
)

export default component.exports